var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6759 11.0003L8.00925 2.83363C7.90749 2.65408 7.75993 2.50474 7.58162 2.40083C7.40331 2.29693 7.20062 2.24219 6.99425 2.24219C6.78787 2.24219 6.58519 2.29693 6.40688 2.40083C6.22856 2.50474 6.081 2.65408 5.97925 2.83363L1.31258 11.0003C1.20973 11.1784 1.1558 11.3806 1.15625 11.5863C1.15671 11.7919 1.21153 11.9939 1.31517 12.1715C1.41881 12.3492 1.56758 12.4963 1.7464 12.5979C1.92522 12.6996 2.12774 12.7521 2.33341 12.7503H11.6667C11.8714 12.7501 12.0725 12.696 12.2497 12.5935C12.4269 12.4911 12.574 12.3438 12.6762 12.1664C12.7785 11.9891 12.8323 11.788 12.8322 11.5833C12.8322 11.3786 12.7783 11.1776 12.6759 11.0003Z",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 5.75V8.08333",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 10.417H7.00583",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.112337dc961ea566e705d63b3a9b9470.svg";
export { ForwardRef as ReactComponent };